import { render } from "./ManageEditAddBoxes.vue?vue&type=template&id=7a124385"
import script from "./ManageEditAddBoxes.vue?vue&type=script&lang=js"
export * from "./ManageEditAddBoxes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__